import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import {
	Avatar,
	Box,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBizLogicActions } from 'stores';

interface RecallInfoPropos {
	content: string;
	ended: boolean;
	id: string;
	startTime: number;
	status: number;
	subject: string;
}

interface RecallInfoBoxProps {
	recallInfo?: Array<RecallInfoPropos>;
}

const RecallInfoBox = ({ recallInfo }: RecallInfoBoxProps) => {
	const { t, i18n } = useTranslation();
	const [showMore, setShowMore] = React.useState(true);
	const { datetimeConversion } = useBizLogicActions();

	const changeToShowLess = () => {
		setShowMore(false);
	};

	const changeToShowMore = () => {
		setShowMore(true);
	};

	if (!recallInfo || recallInfo.length == 0) return null;

	return (
		<>
			<Box
				pl={2}
				pr={2}
				sx={{
					backgroundColor: '#F4F6F6',
					boxShadow: '1px -1px 10px 10px rgb(12 12 12 / 5%)',
					borderRadius: '15px 15px 15px 15px',
					border: 1,
					borderColor: '#990637',
				}}
			>
				<List sx={{ width: '100%' }} disablePadding={true}>
					<ListItem>
						<ListItemAvatar
							sx={{
								justifyContent: 'center',
								display: 'flex',
							}}
						>
							<Avatar sx={{ backgroundColor: '#990637' }}>
								<PriorityHighIcon
									sx={{ width: '35px', height: '35px' }}
								/>
							</Avatar>
							{/* <Avatar src={square} sx={{width:'50px', height:'50px'}}/> */}
						</ListItemAvatar>
						<ListItemText
							primary={
								<Typography
									sx={{
										color: 'primary.main',
										fontWeight: 'bold',
									}}
									variant="body1"
								>
									{showMore && (
										<>
											{t('recall.title')}
											<> </>
											<span
												style={{
													fontSize: 'smaller',
													color: 'white',
													backgroundColor: '#990637',
													borderRadius:
														'15px 15px 15px 15px',
													paddingLeft: '4px',
													paddingRight: '4px',
												}}
											>
												{datetimeConversion(
													recallInfo[0]['startTime'],
													true
												)}
											</span>
										</>
									)}

									{!showMore && <>{t('recall.title')}</>}
								</Typography>
							}
							sx={{ paddingLeft: '1%' }}
						/>
					</ListItem>
					{!showMore &&
						recallInfo.map((obj: RecallInfoPropos, idx: number) => (
							<ListItem key={idx}>
								<ListItemAvatar
									sx={{
										justifyContent: 'center',
										display: 'flex',
									}}
								>
									<TripOriginIcon
										sx={{
											color: 'primary.main',
											width: '20px',
											height: '20px',
											marginBottom: '80%',
										}}
									/>
								</ListItemAvatar>
								<ListItemText
									primary={
										<Typography
											sx={{
												color: 'primary.main',
												wordBreak: 'break-all',
											}}
											variant="subtitle2"
										>
											{datetimeConversion(
												obj.startTime,
												true
											)}
											<> </>
											{obj.ended && (
												<span
													style={{
														color: 'white',
														backgroundColor:
															'#990637',
														borderRadius:
															'15px 15px 15px 15px',
														paddingLeft: '4px',
														paddingRight: '4px',
													}}
												>
													{t('recall.ended')}
												</span>
											)}
										</Typography>
									}
									secondary={
										<Typography
											sx={{
												color: 'primary.main',
												wordBreak: 'break-all',
											}}
											variant="body2"
										>
											{
												JSON.parse(obj.subject)[
													i18n.resolvedLanguage
												]
											}
											<br></br>
											{
												JSON.parse(obj.content)[
													i18n.resolvedLanguage
												]
											}
										</Typography>
									}
									sx={{ paddingLeft: '1%' }}
								/>
							</ListItem>
						))}
					<ListItem style={{ marginTop: '-5%' }}>
						<ListItemAvatar
							sx={{
								justifyContent: 'center',
								display: 'flex',
							}}
						>
							<></>
							{/* <Avatar src={square} sx={{width:'50px', height:'50px'}}/> */}
						</ListItemAvatar>
						<ListItemText
							primary={
								<Typography
									sx={{
										color: 'primary.main',
										alignItems: 'center',
									}}
									variant="body2"
								>
									{showMore && (
										<>
											{
												JSON.parse(
													recallInfo[0].subject
												)[i18n.resolvedLanguage]
											}
											<br></br>
											{/*Using Link here will push unnecessary history state*/}
											<Box
												component="span"
												onClick={changeToShowLess}
												sx={{
													alignItems: 'center',
													display: 'flex',
													textDecoration: 'none',
													color: 'primary.main',
												}}
											>
												{t('recall.showMore')}
												<KeyboardArrowDownIcon />
											</Box>
										</>
									)}

									{!showMore && (
										<Box
											component="span"
											onClick={changeToShowMore}
											sx={{
												alignItems: 'center',
												display: 'flex',
												textDecoration: 'none',
												color: 'primary.main',
											}}
										>
											{t('recall.showLess')}
											<KeyboardArrowUpIcon />
										</Box>
									)}
								</Typography>
							}
							sx={{ paddingLeft: '1%' }}
						/>
					</ListItem>
				</List>
			</Box>
		</>
	);
};

export default RecallInfoBox;
